import request from "@/utils/request.js"

// 商家与品牌-机构环境（跨租户）
export const updateEnvironmentPhotoIgnore = (storeId, updateData) => {
    return request.put(`/organize/environmentPhoto/${storeId}`, updateData);
};

// 商家与品牌-机构环境-详情（跨租户）
export const getEnvironmentPhotoIgnore = (storeId) => {
    return request.get(`/organize/environmentPhoto/${storeId}`)
}

// 合作身份-详情
export const getOrganizeIgnore = (storeId) => {
    return request.get(`/organize/ignoreTenant/${storeId}`)
}

// 合作身份-修改权限
export const updateOrganizePermissionIgnore = (updateData) => {
    return request.put(`/organize/ignoreTenant/permission`, updateData);
};
